import './LikeControl.css';
import React from 'react';
import { ReactComponent as HeartIcon } from '../../resources/icons/HeartIcon.svg';
import { ReactComponent as HeartIconFill } from '../../resources/icons/HeartIcon-fill.svg';
import { getUserCookie } from '../Login/user_session';
import { handleAnalitics } from "../../utils/tealium";
var intlFormat = function intlFormat(num) {
  return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
};
var rounding = function rounding(num, k) {
  if (num >= 1000) return intlFormat(num / 1000) + k;
  return intlFormat(num);
};
var numberWithCommas = function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var LikeControl = function LikeControl(_ref) {
  var handleClick = _ref.handleClick,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 1000 : _ref$count,
    _ref$like = _ref.like,
    like = _ref$like === void 0 ? false : _ref$like,
    rtl = _ref.rtl,
    _ref$shortThousand = _ref.shortThousand,
    shortThousand = _ref$shortThousand === void 0 ? 'k' : _ref$shortThousand,
    analytics = _ref.analytics,
    name = _ref.name,
    params = _ref.params;
  var userCookieName = 'user_session';
  var loginPopupCheck = function loginPopupCheck(handleClick) {
    if (!getUserCookie().login_status) {
      document.body.classList.add('lr-popup--video--open');
      var popup = document.querySelector('.lr-popup--video');
      if (popup) {
        var focusableInner = popup.querySelector('a, button, [tabindex="0"]');
        if (focusableInner) {
          focusableInner.focus();
        }
      }
    } else {
      handleAnalitics({
        params: params,
        title: name,
        objectParamName: "Add To Favorite Param",
        objectParams: analytics
      });
      handleClick();
    }
  };
  return /*#__PURE__*/React.createElement("button", {
    className: "btn--reset buttonRow__btn--btn-lvl1 ".concat(likeControlStyles, "  ").concat(rtl ? rtlStyle : ''),
    onClick: function onClick(e) {
      return loginPopupCheck(function () {
        return handleClick();
      });
    },
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        loginPopupCheck(function () {
          return handleClick();
        });
      }
    }
  }, like ? /*#__PURE__*/React.createElement(HeartIconFill, null) : /*#__PURE__*/React.createElement(HeartIcon, null), numberWithCommas(count));
};
var rtlStyle = "r13efdbs";
var likeControlStyles = "l1kzj1gw";
export default LikeControl;